export default __webpack_public_path__ + "static/media/crown-blue.dedb5480.webp";